// The Reminders page's groups (6.3): Overdue, Today, Tomorrow, Later, Done, by Riyadh dates. Pure, tested in apps/web/test.
import type { Reminder } from '@dpw/shared';
import { addDays, localDate, localDay } from './format';

/** The reminder's day in Riyadh time (a date-only one is its date). */
const dayOf = (r: Reminder) => r.remindDate ?? localDay(r.remindAt!);

/**
 * Overdue, Today, Tomorrow, Later, Done. Tomorrow is the next calendar day in Riyadh (a Thursday reminder for Friday is
 * still Tomorrow); Later is every day after it. Today and Tomorrow show even when empty (on desktop); the rest only with
 * something in them. empty: what an empty group says.
 */
export function groupReminders(all: Reminder[], today = localDate()) {
  const tomorrow = addDays(today, 1);
  const up = all.filter(r => r.state === 'upcoming');
  return [
    { k: 'Overdue', rows: all.filter(r => r.state === 'overdue'), empty: null },
    { k: 'Today', rows: all.filter(r => r.state === 'today' || r.state === 'late'), empty: 'Nothing for today.' },
    { k: 'Tomorrow', rows: up.filter(r => dayOf(r) <= tomorrow), empty: 'Nothing for tomorrow.' },
    { k: 'Later', rows: up.filter(r => dayOf(r) > tomorrow), empty: null },
    { k: 'Done', rows: all.filter(r => r.state === 'done'), empty: null },
  ];
}

